import React from "react";
import "./toolbar.css";
import Logo from "../../assets/media/logos/logo.png";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";

export default function Toolbar(props) {
  const navigate = useNavigate();
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light p-0 m-0">
        <div className="container-fluid bg-transparent p-0 m-0">
          <img
            src={Logo}
            height="70"
            alt=""
            onClick={() => navigate("/Home")}
          />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 mx-6">
              <li className="nav-item dropdown mx-1">
                <div
                  className={`nav-link mx-0 Ahome ${props.style}`}
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={() => navigate("/Home")}
                >
                  Home
                </div>
              </li>
              <li className="nav-item dropdown mx-1">
                <div
                  className={`nav-link dropdown-toggle mx-0 ${props.style}`}
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  About Us
                </div>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => navigate("/About")}
                    >
                      About Us
                    </button>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a
                      className="dropdown-item"
                      onClick={() => navigate("/Iss")}
                    >
                      Integrated Security System
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      Mission & Core Values
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      Organogram
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      MEET OUR TEAM
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      Board Members
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() => navigate("/Location")}
                    >
                      Sundar Industrial Estate Map
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      PIEDMC Official
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown mx-1">
                <div
                  className={`nav-link dropdown-toggle ${props.style} mx-0`}
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Facilities
                </div>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" href="#">
                      Mega Projects{" "}
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown mx-1">
                <div
                  className={`nav-link dropdown-toggle ${props.style} mx-0`}
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Customer Services
                </div>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" href="#">
                      Standard Operating <br />
                      Procedures
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      One Window Operation
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      BOM Phone Numbers
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      Electrical Connections
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown mx-1">
                <div
                  className={`nav-link dropdown-toggle mx-0 ${props.style}`}
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Mobile and Event
                </div>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" href="#">
                      Events & Happenings
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      Documentary
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown mx-1">
                <div
                  className={`nav-link dropdown-toggle mx-0 ${props.style}`}
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="text-upper">Career & Tenders</span>
                </div>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" href="#">
                      Careers
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      Tenders
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      PPRA Rules
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown mx-1">
                <div
                  className={`nav-link dropdown-toggle mx-0 ${props.style}`}
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  E-Biling
                </div>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" href="#">
                      Electric Bills
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      O&M and Aquifer Bills
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      Aqua Bills
                    </a>
                  </li>
                  <hr className="p-0 m-0" />
                  <li>
                    <a className="dropdown-item" href="#">
                      O&M Billing Information
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <form className="form-inline">
              <input
                className="form-control mr-2 search mblview"
                size="35"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
            </form>
            <a>
              <div className="symbol symbol-35px cursor-pointer">
                <Avatar />
              </div>
            </a>
          </div>
        </div>
      </nav>
    </>
  );
}
